
































































import Vue from 'vue';
import customerClient from '@/customer/apis';
import { RemarkGroup } from '@/customer/models/RemarkGroup';
import CustomerRemark from '@/customer/models/CustomerRemark';
import SelectRemarkBox from '@/customer/components/remarks/SelectRemarkBox.vue';

export default Vue.extend({
  components: {
    SelectRemarkBox,
  },
  mounted() {
    this.loadRemarkGroups();
  },
  computed: {
    columnData(): Array<Array<RemarkGroup>> {
      const chunkSize = 10;
      const arr = this.groups;
      const R = [];
      for (let i = 0,len = arr.length; i < len; i+=chunkSize)
        R.push(arr.slice(i, i + chunkSize));
      return R;
    },
  },
  data() {
    return {
      editGroup: null as null | RemarkGroup,
      showEdit: {} as any,
      showDelete: {} as any,
      editName: {} as any,
      groups: [] as Array<RemarkGroup>,
    }
  },
  methods: {
    loadRemarkGroups(): void {
      customerClient.getRemarkGroups({}).success((r: any) => {
        this.groups = r.remarkGroups;
        this.groups.forEach((g: RemarkGroup) => {
          this.$set(this.editName, g.id, g.name);
        });
      });
    },
    handleOpenEditRemarkBox(g: RemarkGroup): void {
      const ref = this.$refs['selectRemarkBoxRef'] as any;
      if(ref) {
        ref.clearSelected();
      }
      this.editGroup = g;
    },
    handleConfirmRemarks(remarks: Array<CustomerRemark>): void {
      const g = this.editGroup;
      this.handleConfirmUpdate(g.id, g.name, remarks.map(r => r.id))
    },
    handleOpenEditBox(id: number, name: string): void {
      this.editName[id] =  name;
      this.showEdit[id] = true;
    },
    handleConfirmUpdate(id: number, name: string, remarkIds: Array<number>): void {
      customerClient.updateRemarkGroup({
        id,
        remarkIds,
        name,
      }).success(() => {
        this.loadRemarkGroups();
        this.showEdit[id] = false;
        this.editGroup = null; // 编辑标签时生效
      }).failure((code) => {
        let msg = '更新失败';
        if(code === 'NameConflict') {
          msg = '标签组名称已存在';
        }
        this.$Message.error(msg);
        this.showEdit[id] = false;
      });
    },
    handleCancelUpdate(id: number): void {
      this.showEdit[id] = false;
    },
    handleOpenDeleteBox(id: number): void {
      this.showDelete[id] = true;
    },
    handleCancelDelete(id: number): void {
      this.showDelete[id] = false;
    },
    handleConfirmDelete(id: number): void {
      customerClient.deleteRemarkGroup({
        id,
      }).success(() => {
        this.loadRemarkGroups();
        this.showDelete[id] = false;
      });
    },
  },
});
